// extracted by mini-css-extract-plugin
module.exports =  {"slider":"K74RzMc8","handle":"IoJIZkbL","bar":"WYxq8oEf","barVisible":"OcNPrWMy","barFill":"N3Vk46ZQ","labels":"drqDVIK9","label":"x9hdl5yq"};